import { getContainer } from '@mews-commander/legacy-app-instance';
import { NumberServiceOptions } from '@mews/framework';

export const localizeCurrencyValue = (
    { value, currency }: { value: number; currency: string },
    options?: NumberServiceOptions
) => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    return appLocalizationComponent.localizeCurrencyValue({ value, currency }, options);
};
